// extracted by mini-css-extract-plugin
export default {"auth":"AuthForm_auth__yktt1","control":"AuthForm_control__YLItP","actions":"AuthForm_actions__yxPCv","toggle":"AuthForm_toggle__7BDkH"};